var map = {
	"./ai.png": "6e5a",
	"./csv.png": "56da",
	"./doc.png": "3eaa",
	"./docs.png": "897f",
	"./else.png": "eb44",
	"./jpeg.png": "1343",
	"./jpg.png": "c9f8",
	"./mp3.png": "fa3f",
	"./pdf.png": "fdf1",
	"./png.png": "61b2",
	"./ppt.png": "d258",
	"./pptx.png": "3cf6",
	"./psd.png": "535e",
	"./txt.png": "d32d",
	"./xls.png": "1874",
	"./xlsx.png": "eb23",
	"./zip.png": "a1b5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3e7f";